import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import calendar from '../../assets/img/icons/calendar.svg'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns';
import Religion from '../commoncomponents/religion';
import Language from '../commoncomponents/language';
import Seeking from '../commoncomponents/seeking';
import ls from "local-storage";
import Cookies from 'universal-cookie';
import axios from 'axios';
import OtpInput from 'react-otp-input';
import Location from '../commoncomponents/location';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Signup extends Component {
    constructor(props) {
        super(props);
        this.onChangeName = this.onChangeName.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            langKey: ls.get('LangValue'),
            api_url: localStorage.getItem('api_url'),
            errorMsg: '',
            errors: {},
            selectedOption: 'male',
            selectedDate: null,
            religionmodalmodal: false,
            langaugemodal: false,
            seekingmodal: false,
            locationmodal: false,
            name: '',
            email: '',
            password: '',
            gender: 'male',
            biography: '',
            phone: '',
            otp: '',
            numInputs: 4,
            separator: '-',
            isDisabled: false,
            hasErrored: false,
            isInputNum: true,
            otpModel: false,
            age: 25,
        };
    }

    componentDidMount() {
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
        
        const cookies = new Cookies();
        this.setState({
            phone:cookies.get('signupmobileno'),
        });
    }

    componentWillMount() {
        localStorage.removeItem('seleted_religion')
        localStorage.removeItem('selected_language')
    }

    handleOptionChange = (changeEvent) => {
        this.setState({
            selectedOption: changeEvent.target.value
        });
    };

    handleChange = event => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleDateChange = date => {
        this.setState({
            selectedDate: date
        });
    };

    handleReligionOpenModal = () => {
        this.setState({ religionmodal: true });
    }

    handleReligionCloseModal = () => {
        this.setState({ religionmodal: false });
    }

    handleLanguageOpenModal = () => {
        this.setState({ langaugemodal: true });
    }

    handleLanguageCloseModal = () => {
        this.setState({ langaugemodal: false });
    }

    handleSeekingOpenModal = () => {
        this.setState({ seekingmodal: true });
    }

    handleSeekingCloseModal = () => {
        this.setState({ seekingmodal: false });
    }

    restrict = (event) => {
        const regex = new RegExp("^[a-zA-Z ]+$");
        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            event.preventDefault(); return false;
        }
    }

    onChangeName(e){
        this.setState({
            name: e.target.value,
        });
    }

    onChangeEmail(e){ 
        this.setState({
            email: e.target.value,
        });
    }

    onChangePassword(e){
        this.setState({
            password: e.target.value
        });
    }

    onSubmit(e) {
        e.preventDefault();
        let errors = {};
        let clickOn = 0;
        var religion = localStorage.getItem('seleted_religion');
        var language = localStorage.getItem('selected_language');

        if(this.state.phone !== null && this.state.phone !== '' &&
            this.state.name !== null && this.state.name !== '' &&
            this.state.email !== null && this.state.email !== '' && 
            this.state.password !== null && this.state.password !== '' &&
            this.state.gender !== null && this.state.gender !== '' &&
            religion !== null && religion !== '' &&
            language !== null && language !== '' &&
            this.state.biography !== null && this.state.biography !== '' && clickOn === 0) {
                var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
                if (!pattern.test(this.state.email)) { 
                    errors["signup"] = "Please enter valid email";     
                    this.setState({ 
                        errors: errors,
                        errorMsg:'errorMsg'
                    });
                    setTimeout(() => {
                        this.setState({ 
                            errors: ''
                        });
                    }, 4000); 
                    clickOn = 0;
                    return;  
                }
                var signup = new FormData();
                signup.append('email', this.state.email);
                signup.append('language', this.state.langKey); 
                clickOn = 1;
                axios({ 
                    method: 'post', 
                    url: this.state.api_url+'webcheckemail',
                    data: signup,
                    config: { headers: {'Content-Type': 'multipart/form-data' }}
                }).then(res => {
                    const message = res.data.message;
                    if(res.data.status === "true") {
                        localStorage.setItem('biography', this.state.biography);
                        localStorage.setItem('name', this.state.name);
                        localStorage.setItem('email', this.state.email);
                        localStorage.setItem('password', this.state.password);
                        localStorage.setItem('dob', this.state.selectedDate);
                        localStorage.setItem('phone', this.state.phone);
                        localStorage.setItem('age', this.state.age);
                        localStorage.setItem('gender', this.state.gender);
                        if(res.data.email_verified === 'disabled') {
                            this.handleSeekingOpenModal();
                        } else {
                            this.setState({ otpModel: true });
                        }
                    } else {
                        signup.set('email', '');
                        errors["signup"] = message;
                        this.setState({
                            errors: errors,
                            errorMsg:'errorMsg'
                        });
                        setTimeout(() => {
                            this.setState({
                                errors: ''
                            });
                        }, 2000);
                    }
                    this.setState({
                        errors: errors
                    });
                    clickOn = 0;
                });
        } else {
            errors["signup"] = "Please fill the details";
            this.setState({ 
                errors: errors,
                errorMsg:'errorMsg'
            });
            setTimeout(() => {
                this.setState({ 
                    errors: ''
                });
            }, 4000); 
            clickOn = 0;
        }
    }

    handleOtpChange = otp => {
        this.setState({ otp });
    };

    clearOtp = () => {
        this.setState({ otp: '' });
    };

    handleResendOtp = e => {
        e.preventDefault(); 
        let errors = {};

        var signup = new FormData();
        signup.append('email', this.state.email);
        signup.append('language', this.state.langKey);  

        axios({
            method: 'post',
            url: this.state.api_url+'webcheckemail',
            data: signup,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => { 
            errors["otpverify"] = res.data.message;  
            this.setState({
                errors: errors,
                errorMsg:'errorMsg'
            });
            setTimeout(() => {
                this.setState({
                    errors: ''  
                });
            }, 2000);
            signup.set('email', '');    
        })
    };

    handleSubmit = e => {
        e.preventDefault(); 
        let errors = {};
        var emailVerify = new FormData();
        emailVerify.set('otp', this.state.otp);
        emailVerify.set('email', this.state.email);
        emailVerify.set('language', this.state.langKey);   
        
        axios({
            method: 'post',
            url: this.state.api_url+'verifyotp',
            data: emailVerify,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => { 
            if(res.data.status !== "true") { 
                errors["otpverify"] = res.data.message;  
                this.setState({
                    errors: errors,
                    errorMsg:'errorMsg'
                });
                setTimeout(() => {
                    this.setState({
                        errors: ''
                    });
                }, 2000);  
            } else { 
                emailVerify.set('otp', ''); 
                emailVerify.set('email', '');
                this.setState({ otpModel: false });
                this.handleSeekingOpenModal();
            }
        })
    };

    handleLocationOpenModal = () => {
        this.setState({ locationmodal: true });
    }

    handleLocationCloseModal = () => {
        this.setState({ locationmodal: false });
    }

    render() {
        const checkedRadioStyle = {
            color: '#FF0B5E',
        };
        const { biography } = this.state;
        const maxLength = 150;
        const {
            otp,
            numInputs,
            separator,
            isDisabled,
            hasErrored,
            isInputNum,
        } = this.state;
        const { t } = this.props;
        return (
            <div className="">
                <Form className="welcome_form" onSubmit={this.onSubmit}>
                    <div className='form_height signupform_height'>
                        {/* Phone */}
                        <Form.Group controlId="formPlaintextEmail" className="welcome_form_div">
                            <Form.Label>
                                <Trans i18nKey="Phone Number">Phone Number</Trans>
                            </Form.Label>
                            <NavLink to="/Signupfirebase">
                                <div className='phone_no_div'>
                                    <div>
                                        <div>
                                            <Form.Control style={{ cursor: 'pointer' }} 
                                            value={this.state.phone} placeholder="" required/>
                                        </div>
                                    </div>
                                </div>
                            </NavLink>
                        </Form.Group>

                        {/* Username */}
                        <Form.Group controlId="formPlaintextEmail" className="welcome_form_div">
                            <Form.Label>
                                <Trans i18nKey="User Name">User Name</Trans>
                            </Form.Label>
                            <div >
                                <Form.Control value={this.state.name} onChange={this.onChangeName} maxLength={20} minLength={3} onKeyPress={(e) => this.restrict(e)} placeholder={t("Enter user name")} required />
                            </div>
                        </Form.Group>

                        {/* Email */}
                        <Form.Group controlId="formPlaintextEmail" className="welcome_form_div">
                            <Form.Label>
                                {/* E-mail */}
                                <Trans i18nKey="E-mail">E-mail</Trans>
                            </Form.Label>
                            <div>
                                <Form.Control type="email" value={this.state.email} onChange={this.onChangeEmail} placeholder={t("Enter your email")} required />
                            </div>
                        </Form.Group>

                        {/* Password */}
                        <Form.Group controlId="formPlaintextPassword" className="welcome_form_div">
                            <Form.Label>
                                <Trans i18nKey="Create Password">Create Password</Trans>
                            </Form.Label>
                            <div>
                                <Form.Control type="password" value={this.state.password} onChange={this.onChangePassword} maxLength={15} minLength={6} placeholder={t("Enter your password")} required />
                            </div>
                        </Form.Group>

                        {/* DOB */}
                        <Form.Group controlId="formPlaintextPassword" className="welcome_form_div">
                            <Form.Label>
                                <Trans i18nKey="Date Of Birth">Date Of Birth</Trans>
                            </Form.Label>
                            <div className='modal_react_date'>
                                <DatePicker
                                    selected={this.state.selectedDate}
                                    onChange={this.handleDateChange}
                                    dateFormat="yyyy-MM-dd"
                                    placeholderText={t("Enter your DOB")}
                                    minDate={new Date("1900-01-01")}
                                    maxDate={new Date()}
                                    customInput={
                                        <div className='modal_react_date_div'>
                                            <input
                                                type="text"
                                                value={this.state.selectedDate ? format(this.state.selectedDate, 'MM/dd/yy') : ''}
                                                placeholder={t("Enter your DOB")}
                                                required
                                            />
                                            <img src={calendar} alt="img" />
                                        </div>
                                    }
                                />
                            </div>
                        </Form.Group>

                        {/* Gender */}
                        <Form.Group controlId="formPlaintextEmail" className="welcome_form_div">
                            <Form.Label>
                                <Trans i18nKey="Gender">Gender</Trans>
                            </Form.Label>
                            <div className='checkbox_div'>
                                <Form.Check
                                    type="radio"
                                    label={<span style={this.state.selectedOption === 'male' ? checkedRadioStyle : null}><Trans i18nKey="Male">Male</Trans></span>}
                                    name="radioGroup"
                                    value="male"
                                    checked={this.state.selectedOption === 'male'}
                                    onChange={this.handleOptionChange}
                                    id="maleRadio"

                                />
                                <Form.Check
                                    type="radio"
                                    label={<span style={this.state.selectedOption === 'female' ? checkedRadioStyle : null}><Trans i18nKey="Female">Female</Trans></span>}
                                    name="radioGroup"
                                    value="female"
                                    checked={this.state.selectedOption === 'female'}
                                    onChange={this.handleOptionChange}
                                    id="femaleRadio"
                                />
                                <Form.Check
                                    type="radio"
                                    label={<span style={this.state.selectedOption === 'others' ? checkedRadioStyle : null}><Trans i18nKey="Others">Others</Trans></span>}
                                    name="radioGroup"
                                    value="others"
                                    checked={this.state.selectedOption === 'others'}
                                    onChange={this.handleOptionChange}
                                    id="othersRadio"
                                />
                            </div>
                        </Form.Group>

                        {/* Religion */}
                        <Form.Group controlId="formPlaintextEmail" className="welcome_form_div">
                            <Form.Label>
                                <Trans i18nKey="Religion">Religion</Trans>
                            </Form.Label>
                            <div>
                                <Form.Control value={localStorage.getItem('seleted_religion')} onClick={this.handleReligionOpenModal} placeholder={t("Select the Religion")} required/>
                            </div>
                        </Form.Group>

                        {/* Language */}
                        <Form.Group controlId="formPlaintextEmail" className="welcome_form_div">
                            <Form.Label>
                                <Trans i18nKey="Language">Language</Trans>
                            </Form.Label>
                            <div>
                                <Form.Control value={localStorage.getItem('selected_language')} onClick={this.handleLanguageOpenModal} placeholder={t("Select the Language")} required/>
                            </div>
                        </Form.Group>

                        {/* Bio */}
                        <Form.Group className="welcome_form_div" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>
                                <Trans i18nKey="Biography">Biography</Trans>
                            </Form.Label>
                            <div className='textarea_position signup_textareaHeight'>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    name="biography"
                                    value={biography}
                                    maxLength={maxLength}
                                    onChange={this.handleChange}
                                    placeholder={t("Write Text...")}
                                    required 
                                />
                                <span className='no_txt'>{biography.length}/{maxLength}</span>
                            </div>
                        </Form.Group>
                    </div>
                    <div className={this.state.errorMsg}>{this.state.errors.signup}</div>
                    <div className='mt_2'>
                        <button className="button_primary">
                            <Trans i18nKey="">SIGN UP</Trans>
                        </button>
                    </div>
                </Form>

                <Religion
                    showModal={this.state.religionmodal}
                    handleClose={this.handleReligionCloseModal}
                />

                <Language
                    showModal={this.state.langaugemodal}
                    handleClose={this.handleLanguageCloseModal}
                />

                <Seeking
                    showModal={this.state.seekingmodal}
                    handleClose={this.handleSeekingCloseModal}
                />

                <Location
                    showModal={this.state.locationmodal}
                    handleClose={this.handleLocationCloseModal}
                />

                <Modal isOpen={this.state.otpModel} toggle={() => this.setState({ otpModel: false })} className="paymentPopup">
                    <ModalHeader>
                        <h4 class="otp-modal-title">Verification</h4>
                    </ModalHeader>
                    <ModalBody className="apd5Imp">
                        <div className="modal-body edit-profile-page">
                            <Form className="" onSubmit={this.handleSubmit}>
                                <div className="user-input-wrp amb20 otpHolder">
                                    <p class="otp-sub-title text-center">Get OTP code from registered mail</p> 
                                    <div className="otp-cnt">
                                        <OtpInput
                                            inputStyle="inputStyle"
                                            numInputs={numInputs}
                                            isDisabled={isDisabled}
                                            hasErrored={hasErrored}
                                            errorStyle="error"
                                            onChange={this.handleOtpChange}
                                            separator={<span>{separator}</span>}
                                            isInputNum={isInputNum}
                                            shouldAutoFocus
                                            value={otp}
                                        />
                                    </div>
                                    <div className={this.state.errorMsg}>{this.state.errors.otpverify}</div> 
                                    <div className="btn-row text-center">
                                        <button className="btn margin-top--large clrBtn" type="button" disabled={isDisabled} onClick={this.clearOtp}>Clear</button>     
                                        <button className="btn margin-top--large vryBtn" disabled={otp.length < numInputs}>Verify</button>
                                    </div> 
                                    <div className="btn-row text-center">
                                        <button className="btn margin-top--large vryBtn" onClick={this.handleResendOtp}>Resend</button>
                                    </div>              
                                </div>                               
                            </Form>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default withTranslation("translations")(Signup);
